import { Link } from 'react-router-dom';

import { truncateText } from '@ui-framework/index';

function name(original) {
  return <Link to={`/rules/edit/${original?.id}`}>{original?.name || ''}</Link>;
}

function description(original) {
  return original?.description || '';
}

function conditions(original) {
  return truncateText(JSON.stringify(original?.conditions) || '');
}

function outcome(original) {
  return truncateText(JSON.stringify(original?.outcome) || '');
}

function priority(original) {
  return original?.priority || '';
}

function isActive(original) {
  return original?.isActive ? 'Active' : 'In-Active';
}

export { name, description, conditions, outcome, priority, isActive };
